export default __webpack_public_path__ + "static/media/Logo.cbba97d2.svg";